import { z } from 'zod';

export const emailSchema = z.string().trim().toLowerCase().max(254).pipe(z.email('E-mail inválido'));
export const passwordSchema = z
  .string()
  .min(8, 'A senha precisa ter pelo menos 8 caracteres')
  .max(200, 'Senha longa demais');
export const nameSchema = z.string().trim().min(1, 'Informe o nome').max(120);

export const loginInput = z.object({ email: emailSchema, password: z.string().min(1).max(200) });
export type LoginInput = z.infer<typeof loginInput>;

export const signupInput = z.object({
  name: nameSchema,
  email: emailSchema,
  password: passwordSchema,
  organizationName: z.string().trim().min(2, 'Informe o nome do estúdio').max(120),
});
export type SignupInput = z.infer<typeof signupInput>;

export const forgotPasswordInput = z.object({ email: emailSchema });
export const resetPasswordInput = z.object({ token: z.string().min(20).max(200), password: passwordSchema });

export const updateProfileInput = z.object({
  name: nameSchema,
  title: z.string().trim().max(80).nullable(),
  timezone: z.string().trim().max(64).nullable(),
});
export type UpdateProfileInput = z.infer<typeof updateProfileInput>;

export const changePasswordInput = z.object({
  currentPassword: z.string().min(1).max(200),
  newPassword: passwordSchema,
});
export type ChangePasswordInput = z.infer<typeof changePasswordInput>;
